import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TaskCompletedByFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: members } = useCurrentOrganizationMembers();
    const { taskCompletedByIds } = filters;

    const labels = useMemo(
        () =>
            members
                ?.filter((member) =>
                    taskCompletedByIds?.includes(member.user.id),
                )
                .map((member) => member.user.name) ?? [],
        [members, taskCompletedByIds],
    );

    if (!taskCompletedByIds || taskCompletedByIds.length === 0) {
        return null;
    }

    return formatFilterLabel(labels);
};
